import { Component, Input, ViewEncapsulation } from '@angular/core';
import { ItemExtraFieldModel } from '../../../../shared/models/payment/order/item-extra-field.model';

@Component({
    selector: 'completed-order-items-attributes-extra-fields',
    templateUrl: './completed.order.items.attributes-extra-fields.component.html',
    styleUrls: ['../../../completed.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class CompletedOrderItemsAttributesExtraFieldsComponent {
    @Input('extraFields') extraFields: Array<ItemExtraFieldModel>;
}



// WEBPACK FOOTER //
// /codebuild/output/src3659550778/src/src/app/completed/order/items/attributes-extra-fields/completed.order.items.attributes-extra-fields.component.ts